import LegalPageShell from "@/components/LegalPageShell";

const SECTIONS = [
  {
    number: 1,
    title: "Information We Collect",
    paragraphs: ["We may collect:"],
    bullets: [
      "Doctor and staff account information",
      "Patient demographic information",
      "Medical history, diagnoses, prescriptions, and lab reports",
      "Appointment and consultation records",
      "AI-generated summaries and insights",
      "Device, browser, and usage information",
    ],
  },
  {
    number: 2,
    title: "How We Use Your Information",
    paragraphs: ["We use your information to:"],
    bullets: [
      "Provide clinic management services",
      "Analyze uploaded medical reports using AI",
      "Generate clinical insights and summaries",
      "Improve platform security and performance",
      "Comply with legal obligations",
    ],
  },
  {
    number: 3,
    title: "AI Processing",
    paragraphs: [
      "Uploaded reports may be securely processed using trusted AI providers to generate clinical summaries, timelines, and insights. AI-generated content is intended to assist healthcare professionals and should always be reviewed by a qualified doctor before making clinical decisions.",
    ],
  },
  {
    number: 4,
    title: "Data Sharing",
    paragraphs: ["We do not sell your personal or medical data.", "We may share data only with:"],
    bullets: ["Cloud hosting providers", "AI service providers", "Payment providers", "Authorities when legally required"],
  },
  {
    number: 5,
    title: "Data Security",
    paragraphs: ["We protect your information using:"],
    bullets: ["Encrypted connections (HTTPS)", "Secure cloud storage", "Role-based access control", "Password encryption", "Regular security monitoring"],
  },
  {
    number: 6,
    title: "Data Retention",
    paragraphs: ["We retain data only as long as necessary to provide our services or comply with applicable laws. Users may request deletion where legally permitted."],
  },
  {
    number: 7,
    title: "Your Rights",
    paragraphs: ["You may request to:"],
    bullets: ["Access your data", "Correct inaccurate information", "Delete your account (subject to legal requirements)", "Withdraw consent where applicable"],
  },
  {
    number: 8,
    title: "Cookies",
    paragraphs: ["We use essential cookies to provide secure login, maintain sessions, and improve your experience."],
  },
  {
    number: 9,
    title: "Changes to This Policy",
    paragraphs: ["We may update this Privacy Policy periodically. The latest version will always be available on our website."],
  },
  {
    number: 10,
    title: "Contact Us",
    paragraphs: ["For privacy-related questions, please contact:", "RootLyst Support", "Email: contact@rootlyst.com"],
  },
];

export default function PrivacyPolicyPage() {
  return (
    <LegalPageShell
      testId="privacy-policy-page"
      title="Privacy Policy"
      effectiveDate="18/07/2026"
      lastUpdated="18/07/2026"
      intro="Welcome to RootLyst, an AI-powered clinic management platform for healthcare professionals. Your privacy is important to us."
      sections={SECTIONS}
    />
  );
}
